// https://railsdesigner.com/modal-with-rails-hotwire/

import ModalController from "../common/modal_controller";

export default class extends ModalController {
  connect(): void {
    const element = this.element as HTMLElement;
    this.initializeFocusTrap(element);
    element.focus();
  }

  closeModal(event: Event): void {
    event.preventDefault();
    const element = this.element as HTMLElement;
    if (this.focusTrap) {
      this.focusTrap.deactivate();
      this.focusTrap = null;
    }
    element.remove();
  }
}
